module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularWeb-MediumItalic.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularWeb-MediumItalic.woff
 ** module id = 1108
 ** module chunks = 0
 **/